import { ref, reactive } from 'vue'

export default function useMap(props) {
    const mapInitialized = ref(false)

    // astana
    const defaultLocation = {
        lat: 51.1248382,
        lng: 71.4345164,
    }
    const map = reactive({
        center: props.value ? [props.value.lat, props.value.lng] : [defaultLocation.lat, defaultLocation.lng],
        marker: {
            lat: props.value ? props.value.lat : defaultLocation.lat,
            lng: props.value ? props.value.lng : defaultLocation.lng,
        },
        options: {
            zoomControl: false,
        },
        tileLayer: {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        zoom: 16,
    })

    const setLocation = (location) => {
        // set map
        map.center = [location.lat, location.lng]
        map.marker.lat = location.lat
        map.marker.lng = location.lng
    }

    const clearLocation = () => {
        // empty selected
        map.search.selected = null

        // reset marker to dundee office
        map.center = [defaultLocation.lat, defaultLocation.lng]
        map.marker.lat = defaultLocation.lat
        map.marker.lng = defaultLocation.lng
    }


    return {
        mapInitialized,
        map,
        setLocation,
        clearLocation,
    }
}
